import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType, ShiftInfo } from "../../../../../controls";

type Props = {
	setShiftId: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowEditModal: Function;
};
export const useShiftsOptionsFunctions = ({
	setShiftId,
	setShowDeleteModal,
	setShowCreateModal,
	setShowEditModal,
}: Props) => {
	const getMenuOptions = (data: ShiftInfo) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Shift",
					key: "new_shift",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Shift",
					key: "new_shift",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Shift",
					key: "edit_shift",
					onClick: () => {
						setShiftId(data);
						setShowEditModal(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Shift",
					key: "delete_shift",
					onClick: () => {
						setShiftId(data);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
